(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ze-shopping-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ze-purchase-gate')) return;
    const choices = new Map();
    const pending = new Set();
    const observedForms = new WeakSet();
    const gates = formId => [...document.querySelectorAll('ze-purchase-gate')].filter(gate => gate.getAttribute('form-id') === formId);
    const sync = formId => {
      const chosen = choices.get(formId) === true;
      gates(formId).forEach(gate => {
        const fieldset = gate.querySelector('.ze-purchase-fieldset');
        const notice = gate.querySelector('.ze-size-notice');
        if (fieldset) fieldset.disabled = !chosen || pending.has(formId);
        if (notice) notice.hidden = chosen;
      });
      document.querySelectorAll('variant-picker').forEach(picker => {
        if (picker.getAttribute('form-id') !== formId) return;
        picker.querySelectorAll('[data-ze-size-option]').forEach(option => {
          option.toggleAttribute('data-ze-size-pending', !chosen);
          const prompt = option.querySelector('[data-ze-size-prompt]');
          if (prompt) prompt.hidden = chosen;
        });
      });
    };
    customElements.define('ze-purchase-gate', class extends HTMLElement {
      connectedCallback() {
        const formId = this.getAttribute('form-id');
        if (!choices.has(formId)) choices.set(formId, this.hasAttribute('initial-choice'));
        const form = document.forms[formId];
        if (form && !observedForms.has(form)) {
          observedForms.add(form);
          form.addEventListener('variant:change', () => {
            pending.delete(formId);
            sync(formId);
          });
        }
        sync(formId);
      }
    });
    document.addEventListener('click', event => {
      const input = event.target.closest('input[data-option-position]');
      if (!input?.closest('[data-ze-size-option], [data-ze-size-values]')) return;
      const formId = input.getAttribute('form');
      if (!choices.has(formId)) return;
      choices.set(formId, true);
      sync(formId);
    }, true);
    document.addEventListener('change', event => {
      const input = event.target.closest('input[data-option-position]');
      const formId = input?.getAttribute('form');
      if (!choices.has(formId)) return;
      if (input.closest('[data-ze-size-option], [data-ze-size-values]')) choices.set(formId, true);
      pending.add(formId);
      sync(formId);
    }, true);
    document.addEventListener('variant:change', event => {
      pending.delete(event.detail.formId);
      sync(event.detail.formId);
    });
    document.addEventListener('submit', event => {
      if (choices.get(event.target.id) !== false && !pending.has(event.target.id)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      [...document.querySelectorAll('variant-picker')].find(picker => picker.getAttribute('form-id') === event.target.id)?.querySelector('[data-ze-size-option] button')?.focus();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
